export default __webpack_public_path__ + "static/media/github-search.9f78a58b.svg";